import { AsyncPipe, CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ToastService } from '@app/services/toast.service';

@Component({
  selector: 'app-toasts',
  standalone: true,
  imports: [CommonModule, AsyncPipe],
  template: `
    <div class="position-fixed top-0 end-0 p-3" style="z-index: 1080">
      <ng-container *ngFor="let t of toast.toasts | async">
        <div
          class="toast show border-0"
          role="alert"
          aria-live="polite"
          aria-atomic="true"
          [class.text-bg-success]="t.level === 'success'"
          [class.text-bg-danger]="t.level === 'danger'"
          [class.text-bg-warning]="t.level === 'warning'"
          [class.text-bg-primary]="!t.level || t.level === 'info'"
        >
          <div class="d-flex">
            <div class="toast-body">{{ t.message }}</div>
            <button
              type="button"
              class="btn-close me-2 m-auto"
              [class.btn-close-white]="t.level !== 'warning'"
              (click)="toast.remove(t.id)"
              aria-label="Close"
            ></button>
          </div>
        </div>
      </ng-container>
    </div>
  `,
})
export class ToastsContainerComponent {
  toast = inject(ToastService);
}
